const mutations =  {
  setProchipDropdownValues(state, responseData) {
    state.years = responseData.year;
    state.cplds = responseData.cpld;
    state.cpldVolumes = responseData.cpldVolume;
    state.hdls = responseData.hdl;
  },
  setDBUpdateStatus(state, prochipData) {
    state.prochipData = prochipData;
  },
  setAPIError(state, isError) {
    state.isProchipAPIError = isError;
  },
  resetDBResponse(state, prochipData) {
    state.prochipData = prochipData;
  },
   setAccessToken(state, payload) {
    state.accessToken = payload;
  },
  setUserProfileDetails(state, payload) {
    state.userProfileDetails = payload;
  }
};

export default mutations;